import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";
import adminRouter from "@/router/admin";
import adminCustomerRouter from "@/router/adminCustomer";
import customerRouter from "@/router/customer";
import loginPage from "@/views/pages/login.vue";
import resetPage from "@/views/pages/reset.vue";
import _ from "lodash";
import { ADMIN_TYPE, CUSTOMER_TYPE } from "@/common/constant";
import { CUSTOMER_AUTHORITY } from "@/model/customerUser";
import $ from "jquery";

// import {
//   ROLE_ADMIN,
//   ROLE_ADMIN_CUSTOMER,
//   ROLE_CUSTOMER,
// } from "@/common/constant";
Vue.use(VueRouter);

const baseRouter: Array<RouteConfig> = [
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      pageTitle: "HORIKOSHI公式購入サイト | 株式会社HORIKOSHI",
      bodyClass: "mb__admin mb__login",
    },
    component: loginPage,
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      pageTitle: "HORIKOSHI公式購入サイト | 株式会社HORIKOSHI",
      bodyClass: "mb__admin mb__login",
    },
    component: resetPage,
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/pages/logout.vue"),
  },
];

const routes = [
  ...baseRouter,
  ...adminRouter,
  ...customerRouter,
  ...adminCustomerRouter,
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.NODE_ENV === "development" ? process.env.BASE_URL : "",
  routes,
});
router.beforeEach(async (to, from, next) => {
  console.log(to);
  let allowAccess = true;
  if (
    !store.state.Auth.token
  // || (store.state.Auth.customer_user &&
  // store.state.Auth.customer_user.is_changed_password == false)
  ) {
    allowAccess = false;
  }

  if (
    store.state.Auth.token &&
    store.state.Auth.user_type &&
    to.meta.allowRole &&
    !to.meta.allowRole.includes(store.state.Auth.user_type)
  ) {
    next({ name: "notFound" });
    return;
  }

  if (!allowAccess) {
    if (
      to.name == "login" ||
      to.name == "forgot.email" ||
      to.name == "reset-password"
    ) {
      next();
    } else {
      next({ name: "login" });
    }
  } else if (to.name == "login") {
    if (store.state.Auth.user_type === ADMIN_TYPE) {
      next({ name: "admin.default" });
    } else if (store.state.Auth.user_type === CUSTOMER_TYPE) {
      if (
        store.state.Auth.customer_user.account_authority ==
        CUSTOMER_AUTHORITY.ADMIN_CUSTOMER
      ) {
        next({ name: "admin-customer.default" });
      } else {
        next({ name: "front.home" });
      }
    }
  }

  next();

  const errorRouter = ["forbidden", "error", "notFound"];
  if (from.name && from.name != to.name && !errorRouter.includes(to.name)) {
    let query = {};
    switch (to.name) {
    case "admin.admin-customers":
      query = store.state.Router.searchParameters ? store.state.Router.searchParameters.adminCustomer : {};
      break;
    case "admin.order-histories":
    case "admin-customer.order-histories":
      query = store.state.Router.searchParameters ? store.state.Router.searchParameters.orderHistory : {};
      break;
    }
    query = _.pickBy(query, (item) => item);
    next({ name: to.name, query: query });
  }
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || "";
    document.body.setAttribute("class", to.meta.bodyClass);
    $("#menu_bar").removeClass("open");
  });
});
export default router;
